// extracted by mini-css-extract-plugin
module.exports = {"root":"root___1jR_1","inner":"inner___1dC3I"};